import PageHead from "@/components/header/PageHead";
import BindNodeComponent from '@/components/bindNode/BindNodeComponent';
import { getPrefix } from "@/utils/common";
export default {
  name: "CollateralNode",
  components: {
    PageHead,
    BindNodeComponent
  },
  data() {
    return {
      nodeId: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.nodeId = getPrefix() + this.$route.params.provider;
      await this.$store.dispatch('getNodePublicInfo', {
        nodeId: this.nodeId
      });
      await this.$refs['bindNodeComponent'].init();
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};